import { ViewportScroller } from '@angular/common';
import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, ActivatedRoute } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { PaginationService } from 'src/app/PaginationService';
import { AppService } from 'src/app/app.service';
import { messageService } from 'src/app/message.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';

@Component({
  selector: 'app-schedulers-detail',
  templateUrl: './schedulers-detail.component.html',
  styleUrls: ['./schedulers-detail.component.scss']
})
export class SchedulersDetailComponent implements OnInit {

  schedulerData: any = {};
  searchText: any;
  searchValue: any;
  isProcessing = true;
  _temp: any = {};
  columnLists: any = {};
  scheduledJobRunsList: any = [];
  makeStickyColumns: any;
  dataTypeList: any = [];
  schedulerOptions: any = [];
  schedulerOptionDropdown: any = [];
  selectedSchedulerOption: any = null;
  selectedSchedulerOptionValue: any;

  dateTimePickerConfiguration = {
    dateInputFormat: 'DD-MMM-YYYY HH:mm:ss',
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }
  dateFormat: any = this.appService.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';
  datePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }


  @ViewChild('cancelSchedulePopup', { static: true }) cancelSchedulePopup: TemplateRef<any>;
  @ViewChild('createSchedulePopup', { static: true }) createSchedulePopup: TemplateRef<any>;
  visibleCancelSchedulePopup: MatDialogRef<TemplateRef<any>>;
  visibleCreateSchedulePopup: MatDialogRef<TemplateRef<any>>;

  cancelSchedulePopupConfig = {
    width: '500px',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  createSchedulePopupConfig = {
    width: '600px',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };


  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  dateCustomClasses: DatepickerDateCustomClasses[];
  constructor(private readonly _formBuilder: FormBuilder, private readonly appService: AppService, private readonly router: Router, public dialog: MatDialog,
    private readonly scroller: ViewportScroller, private readonly snackBar: MatSnackBar, private readonly activatedRoute: ActivatedRoute,
    private readonly message: messageService, public paginationService: PaginationService, private readonly elem: ElementRef) {
    const data: any = router.getCurrentNavigation()?.extras.state;
    this.schedulerData = data['scheduledData'];
    if (this.schedulerData.startDate != null) {
      this.schedulerData.startDate = new Date(this.schedulerData.startDate);
    }
    if (this.schedulerData.endDate != null) {
      this.schedulerData.endDate = new Date(this.schedulerData.endDate);
    }
    if (this.schedulerData.lastStartDate != null) {
      this.schedulerData.lastStartDate = new Date(this.schedulerData.lastStartDate);
    }
    if (this.schedulerData.nextRunDate != null) {
      this.schedulerData.nextRunDate = new Date(this.schedulerData.nextRunDate);
    }
  }

  visibleDataGrid: boolean = false;
  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages

  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;

  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  private readonly users: any[];
  pager: any = {};
  pagedItems: any[];
  error = '';
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.scheduledJobRunsList.length, page, this.perPage, targetpage);
    this.pagedItems = this.scheduledJobRunsList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  getcallMethod() {
    this.isProcessing = true;
    this.scheduledJobRunsList = [];
    const data = {

      gridName: "SCHEDULED_JOB_RUNS",
      jobName: this.schedulerData.scheduledJobName
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {

        response.orderByClause ??= "";


        this.makeStickyColumns = response.fixedFieldCnt;

        const data1: any = {

          gridName: "ONEQMS_SCHEDULED_JOB_RUNS_VW",
          jobName: this.schedulerData.scheduledJobName,
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        }

        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.scheduledJobRunsList = response1;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");



            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              let width = Number.parseInt(data1.fieldSizeListArray[p]);
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": width + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const size of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(size + 'px');
            }

            let y = 0;
            while (y < this.columnLists.columnsListarray.length) {
              const currentColumn = this.columnLists.columnsListarray[y];
              const isInvisible = this.columnLists.invisibleColumnarray.includes(currentColumn);
              if (isInvisible) {
                this.columnLists.columnsListarray.splice(y, 1);
                this.columnLists.fieldColumnarray.splice(y, 1);
                this.columnLists.fieldSizeListArray.splice(y, 1);
              } else {
                y++;
              }
            }

            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const dataType of this.dataTypeList) {
                  if (dataType.columnName === this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = dataType.fieldType;
                  }
                }
              }
              for (const jobRun of this.scheduledJobRunsList) {
                for (const dataType of this.dataTypeList) {
                  if (dataType.fieldType === 'CHECKBOX') {
                    const colName = dataType.columnName;
                    jobRun[colName] = jobRun[colName] === "Y";
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.setPage(1, 0);
            });
            this.message.gridList = this.scheduledJobRunsList;
            this.collectionSize = this.scheduledJobRunsList.length;
            this.totalPages = Math.ceil(this.scheduledJobRunsList.length / this.itemsPerPage);

          }, error: (error) => {
            this.isProcessing = false
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });

  }

  refreshGridData() {
    this.getcallMethod();
  }

  todayDate: Date;
  ngOnInit() {
    this.getcallMethod();
    const now = new Date();
    this.todayDate = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];

    this.appService.getSchedulerOptions().subscribe((data: any) => {
      this.schedulerOptions = data;
      for (const option of this.schedulerOptions) {
        this.schedulerOptionDropdown.push({
          valueExp: option.schedulerOption,
          displayExp: option.schedulerOption
        });
      }
    })
  }

  minEndDate: Date;
  setVal(startDate: Date) {
    let minenddate = new Date(startDate);
    minenddate.setDate(minenddate.getDate());
    minenddate.setMonth(minenddate.getMonth());
    minenddate.setFullYear(minenddate.getFullYear());
    minenddate.setHours(minenddate.getHours());
    minenddate.setMinutes(minenddate.getMinutes() + 5);
    minenddate.setSeconds(minenddate.getSeconds() + 60);
    this.minEndDate = minenddate;

  }

  setEndVal(startDate: Date) {
    let minenddate = new Date(startDate);
    minenddate.setDate(minenddate.getDate());
    minenddate.setMonth(minenddate.getMonth());
    minenddate.setFullYear(minenddate.getFullYear());
    minenddate.setHours(minenddate.getHours());
    minenddate.setMinutes(minenddate.getMinutes() + 5);
    minenddate.setSeconds(minenddate.getSeconds() + 60);
    this.scheduledEndDate = minenddate;

  }


  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();

    if (filter === '') {
      this.pagedItems = this.scheduledJobRunsList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.scheduledJobRunsList.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)

      );
    }
  }

  focusEmpty() {
    console.log();
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })


    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          let keyValue = p / 2;
          console.log(keyValue);
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }

    })
  }

  onClick(event: any) {

  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  dataGridParentCheckBoxChecked(e: any) {
    const isChecked = e.target.checked;

    this.childCheckBoxs = isChecked;

    for (const jobRun of this.scheduledJobRunsList) {
      jobRun.childCheckBoxs = isChecked;
    }
  }
  priviousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.priviousSelectedValue != undefined) {
        this.scheduledJobRunsList[this.priviousSelectedValue].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
    } else {
      list.childCheckBoxs = false;
    }
    this.priviousSelectedValue = idx;
  }

  back() {
    this.message.breadcrumbData.thirdLevel = null;
    history.back();
  }

  /*   onSchedulerOptionSelect(item : any){
      this.selectedSchedulerOptionValue = item.valueExp;
    } */

  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }
  scheduledIntervalsearchTxt: any;
  onSchedulerOptionSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (item) {
          this.selectedSchedulerOptionValue = item.valueExp;
        } else {
          this.selectedSchedulerOptionValue = null;
        }
      }
    }
  }
  /*
    onSchedulerOptionRemoved(item : any){
      this.selectedSchedulerOptionValue = null;
    }
   */
  title: any;
  scheduledStartDate: any;
  scheduledEndDate: any;
  createScheduleFunc(value: any) {
    this.title = value;
    this.scheduledStartDate = null;
    this.scheduledEndDate = null;
    this.selectedSchedulerOption = null;
    this.selectedSchedulerOptionValue = null;
    this.visibleCreateSchedulePopup = this.dialog.open(this.createSchedulePopup, this.createSchedulePopupConfig);
  }

  cancelScheduleFunc() {
    this.visibleCancelSchedulePopup = this.dialog.open(this.cancelSchedulePopup, this.cancelSchedulePopupConfig);
  }

  cancelScheduleOkFunc() {
    this.isProcessing = true;
    let data: any = {

      "schedulerName": this.schedulerData.schedulerName
    }
    this.appService.cancelScheduler(data).subscribe({
      next: (response: any) => {
        this.isProcessing = false;
        if (response.resultType == "S") {
          this.visibleCancelSchedulePopup.close();
          this.isProcessing = true;
          this.appService.getSchedulerByName(this.schedulerData.scheduledJobName).subscribe((data: any) => {
            this.schedulerData = data[0];
            this.isProcessing = false;
            if (this.schedulerData.startDate != null) {
              this.schedulerData.startDate = new Date(this.schedulerData.startDate);
            }
            if (this.schedulerData.endDate != null) {
              this.schedulerData.endDate = new Date(this.schedulerData.endDate);
            }
            if (this.schedulerData.lastStartDate != null) {
              this.schedulerData.lastStartDate = new Date(this.schedulerData.lastStartDate);
            }
            if (this.schedulerData.nextRunDate != null) {
              this.schedulerData.nextRunDate = new Date(this.schedulerData.nextRunDate);
            }
          })
        }
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: response.resultType == 'S' ? 5000 : undefined,
          data: {
            message: response.result,
            type: response.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok",
            pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: response.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  cancelCancelScheduleFunc() {
    this.visibleCancelSchedulePopup.close();
  }

  cancelCreateScheduleFunc() {
    this.visibleCreateSchedulePopup.close();
  }

  scheduleStartDatecss: any;
  scheduleEndDatecss: any;
  scheduledIntervalcss: any;
  scheduledStartDateReqdMsg: any;
  scheduledEndReqdMsg: any;
  scheduledIntervalReqdMsg: any;
  feildValidation() {
    this.scheduleStartDatecss = document.getElementById('scheduledStartDate') as HTMLInputElement;
    this.scheduleEndDatecss = document.getElementById('scheduledEndDate') as HTMLInputElement;
    this.scheduledIntervalcss = document.getElementById('scheduledInterval') as HTMLInputElement;
    this.scheduledStartDateReqdMsg = document.getElementById('scheduledStartDate-required-msg') as HTMLInputElement;
    this.scheduledEndReqdMsg = document.getElementById('scheduledEndDate-required-msg') as HTMLInputElement;
    this.scheduledIntervalReqdMsg = document.getElementById('scheduledInterval-required-msg') as HTMLInputElement;

    if (this.scheduledStartDate == null) {
      this.scheduleStartDatecss.style.border = '1px solid red';
      this.scheduledStartDateReqdMsg.style.display = 'block';
    } else {
      this.scheduleStartDatecss.style.border = 'none';
      this.scheduledStartDateReqdMsg.style.display = 'none';
    }

    if (this.scheduleEndDatecss == null) {
      this.scheduleEndDatecss.style.border = '1px solid red';
      this.scheduledEndReqdMsg.style.display = 'block';
    } else {
      this.scheduleEndDatecss.style.border = 'none';
      this.scheduledEndReqdMsg.style.display = 'none';
    }

    if (this.selectedSchedulerOptionValue == null) {
      this.scheduledIntervalcss.style.border = '1px solid red';
      this.scheduledIntervalReqdMsg.style.display = 'block';
    } else {
      this.scheduledIntervalcss.style.border = 'none';
      this.scheduledIntervalReqdMsg.style.display = 'none';
    }
  }

  createScheduleOkFunc() {
    if (this.title == "Create Schedule" && (this.scheduledStartDate == null || this.scheduledEndDate == null || this.selectedSchedulerOptionValue == null)) {
      this.feildValidation();
    } else {

      if (this.scheduledStartDate) {
        this.scheduledStartDate = new Date(this.scheduledStartDate);
        this.scheduledStartDate = this.appService.dateZoneConvertion(this.scheduledStartDate);
      } else {
        this.scheduledStartDate = null;
      }

      if (this.scheduledEndDate) {
        this.scheduledEndDate = new Date(this.scheduledEndDate);
        this.scheduledEndDate = this.appService.dateZoneConvertion(this.scheduledEndDate);
      } else {
        this.scheduledEndDate = null;
      }
      this.isProcessing = true;
      let data: any = {

        "schedulerName": this.schedulerData.schedulerName,
        "startDate": this.scheduledStartDate,
        "endDate": this.scheduledEndDate,
        "repeatInterval": this.selectedSchedulerOptionValue
      }

      this.appService.createScheduler(data).subscribe({
        next: (response: any) => {
          this.isProcessing = false;
          if (response.resultType == "S") {
            this.visibleCreateSchedulePopup.close();
            this.isProcessing = true;
            this.appService.getSchedulerByName(this.schedulerData.scheduledJobName).subscribe((data: any) => {
              this.schedulerData = data[0];
              if (this.schedulerData.startDate != null) {
                this.schedulerData.startDate = new Date(this.schedulerData.startDate);
                this.schedulerData.startDate = this.appService.dateZoneConvertion(this.schedulerData.startDate);
              }
              if (this.schedulerData.endDate != null) {
                this.schedulerData.endDate = new Date(this.schedulerData.endDate);
                this.schedulerData.endDate = this.appService.dateZoneConvertion(this.schedulerData.endDate);
              }
              if (this.schedulerData.lastStartDate != null) {
                this.schedulerData.lastStartDate = new Date(this.schedulerData.lastStartDate);
                this.schedulerData.lastStartDate = this.appService.dateZoneConvertion(this.schedulerData.lastStartDate);
              }
              if (this.schedulerData.nextRunDate != null) {
                this.schedulerData.nextRunDate = new Date(this.schedulerData.nextRunDate);
                this.schedulerData.nextRunDate = this.appService.dateZoneConvertion(this.schedulerData.nextRunDate);
              }
              this.isProcessing = false;
            })
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: response.resultType == 'S' ? 5000 : undefined,
            data: {
              message: response.result,
              type: response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok",
              pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }
  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.scheduledJobRunsList.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA! < valueB!) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA! > valueB!) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }
}
